"use client";

import { IconLoader2 } from "@tabler/icons-react";
import { useState } from "react";
import { isEmail } from "validator";

export function ContactForm() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");
  const [statusMessage, setStatusMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name) {
      setStatusMessage("Please enter your name");
      setStatus("error");
      return;
    }

    if (!email || !isEmail(email)) {
      setStatusMessage("Please enter your email address");
      setStatus("error");
      return;
    }

    if (!message || message.length < 30) {
      setStatusMessage("Please enter your message, min length 30 characters");
      setStatus("error");
      return;
    }

    setStatus("loading");
    setStatusMessage("");

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, name, message }),
      });

      const data = await response.json();

      if (response.ok) {
        setStatusMessage(data.message || "Message sent successfully!");
        setStatus("success");
        setEmail("");
        setName("");
        setMessage("");
      } else {
        setStatusMessage(data.error || "Failed to send message");
        setStatus("error");
      }
    } catch {
      setStatusMessage("Network error. Please try again.");
      setStatus("error");
    }
  };

  return (
    <div className="w-full max-w-[580px] mx-auto">
      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-4 w-full"
      >
        <div className="flex flex-col w-full">
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={status === "loading"}
            className="px-4 py-3 mb-3 rounded-none border border-black/80 bg-white text-black placeholder-black/60 focus:outline-none focus:ring-2 focus:ring-black w-full disabled:opacity-50"
          />
          <input
            type="text"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={status === "loading"}
            className="px-4 py-3 mb-3 rounded-none border border-black/80 bg-white text-black placeholder-black/60 focus:outline-none focus:ring-2 focus:ring-black w-full disabled:opacity-50"
          />
          <textarea
            name="message"
            placeholder="Your message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            disabled={status === "loading"}
            rows={5}
            className="px-4 py-3 rounded-none border border-black/80 bg-white text-black placeholder-black/60 focus:outline-none focus:ring-2 focus:ring-black w-full disabled:opacity-50 resize-none"
          />
        </div>
        <div className="flex flex-row w-full items-center justify-between">
          {/* Fixed height container to prevent layout shifts */}
          <div className="w-full text-left">
            {(
              <div
                className={`text-sm ${
                  status === "success" ? "text-green-600" : "text-red-600"
                }`}
              >
                {statusMessage || " "}
              </div>
            )}
          </div>
          <button
            type="submit"
            disabled={status === "loading"}
            className="px-6 shrink-0 py-3 w-32 text-center bg-black text-white font-bold rounded-none border border-black/80 hover:bg-gray-800 transition disabled:opacity-50 disabled:cursor-not-allowed self-end"
          >
            {status === "loading" ? (
              <IconLoader2 className="animate-spin inline-block" />
            ) : (
              "SEND"
            )}
          </button>
        </div>
      </form>
    </div>
  );
}
